import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicSummaryStorage = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Summary"
      takeaways={[
        { text: "RAID levels are the most important topic in this module. Learn them first." },
        { text: "After RAID, focus on the organization and structure of disk drives." },
        { text: "Learn the remaining topics only after mastering RAID and disk drive organization." }
      ]}
      videos={[]} // No videos provided
      questions={[]} // No questions provided
      exampleVideos={[]} // No example videos provided
    />
);
}

export default ModuleSubtopicSummaryStorage;
